import process from 'process';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'whatwg-fetch';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/tokens.css';
import './styles/stylesheets/bootstrap/bootstrap.css';
import './styles/theme.css';
import './styles/base.css';
import App from './App';

window.process = process;

const root = createRoot(document.getElementById('root'));
root.render(<App />);
